import styled from 'styled-components';

const Tag = (component) => styled(component)`
  margin-inline-end: 8px;
  margin-block-end: 8px;

  /* Mimicking antd 4 blue tag colors — do not touch */
  &.ant-tag.ant-tag-blue:not(.ant-tag-disabled).ant-tag-filled {
    color: #096dd9;
    background-color: #e6f7ff;
    border-color: #91d5ff;
  }

  .anticon-close {
    line-height: 0;
  }
`;

export default Tag;
